import { AdyenEnv } from '@src/meta/types/billing/adyen';
import { PaypalEnv } from '@src/meta/types/billing/paypal';

import baseConfig from '../baseConfig';
import { DefaultThemePaymentOptionsConfig } from '../config.types';
import AppConfig, {
  Auth0ConfigEntry,
  ClientsInfoMappingConfig,
  CommonServicesConfig,
} from '../../baseAppConfig.types';
import prodEndpoints from './common/prodEndpoints';
import { Environment } from '../../baseAppConfig';
import clientsInfo from './common/prodClientsInfo';

const prodServicesConfig: CommonServicesConfig & Auth0ConfigEntry & ClientsInfoMappingConfig = {
  ...clientsInfo,

  auth0Config: {
    issuer: 'https://login.planet.com/',
    clientId: '6Aj5TX4MNCllRVi9C4mPDH0eLUwoEs3H',
  },

  appsBaseUrl: 'https://apps.sentinel-hub.com/',
  pipAccountUrl: 'https://insights.planet.com/account/',
  configurationTemplateAccountId: 'b191955e-d7bc-48eb-971e-9b6fd0a3299f',

  sentry: {
    dsn: 'https://5336c02b48194ca09ac6f65803f0d663@sentry.io/1339645',
    env: 'prod',
    enable: true,
  },

  analytics: {
    trackingID: 'DQMEKKLA',
    enable: true,
  },

  environment: Environment.PRODUCTION,
};

const claimsConfig = {
  accountClaimsKey: 'pl_project',
  userClaimsKey: 'sh_user_id',
};

const prodPaymentConfig: DefaultThemePaymentOptionsConfig = {
  adyenClientId: 'live_GHP4REL4JZDTNESRJUKBD7G56EBFFMPP',
  adyenEnvironment: AdyenEnv.LIVE,
  paypalEnv: PaypalEnv.PRODUCTION,
};

const prodConfig: AppConfig = {
  ...baseConfig,
  ...prodServicesConfig,
  ...prodEndpoints,
  ...prodPaymentConfig,
  ...claimsConfig,
};

export default prodConfig;
